import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { Mail, LogOut, PauseCircle, Phone } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

export default function Sospeso() {
  const { user, logout } = useAuth();
  const [info, setInfo] = useState(null);
  useEffect(() => { api.get("/me/tenant-status").then((r) => setInfo(r.data)).catch(() => setInfo({ status: "attivo" })); }, []);
  if (user === null || info === null) return <div className="min-h-screen bg-[#0A0E17]" />;
  if (!user) return <Navigate to="/login" replace />;
  if (info.status !== "sospeso" || info.is_super_admin) return <Navigate to="/" replace />;
  const subject = encodeURIComponent(`Assistenza NOUVELLE WHATSAPP – ${info.tenant_name || ""}`);
  return (
    <div className="min-h-screen bg-[#0A0E17] flex items-center justify-center px-4" data-testid="suspended-page">
      <div className="w-full max-w-lg bg-[#111827] border border-[#1F2937] rounded-3xl p-8 space-y-6 shadow-2xl">
        <div className="flex items-center gap-4">
          <img src="/logo.png" alt="Nouvelle WhatsApp" className="h-14 w-14 rounded-2xl bg-[#0F172A] p-1.5" data-testid="suspended-logo" />
          <div><p className="text-[11px] uppercase tracking-[0.2em] text-slate-500">NOUVELLE WHATSAPP</p><p className="text-sm text-slate-300 font-medium" data-testid="suspended-tenant-name">{info.tenant_name}</p></div>
        </div>
        <div className="space-y-2">
          <h1 className="font-display text-2xl text-slate-100 flex items-center gap-2" data-testid="suspended-title"><PauseCircle className="h-6 w-6 text-amber-400" /> Servizio temporaneamente sospeso</h1>
          <p className="text-sm text-slate-400">L'accesso alle funzioni operative della piattaforma per la tua azienda è al momento sospeso. I dati sono conservati e il servizio potrà essere riattivato da Studio Nouvelle.</p>
        </div>
        {info.message && <div className="rounded-2xl bg-[#0A0E17] border border-[#1F2937] p-4 text-sm text-slate-200 whitespace-pre-wrap" data-testid="suspended-message">{info.message}</div>}
        <div className="rounded-2xl border border-[#1F2937] p-4 space-y-2 text-sm">
          <p className="text-slate-300 font-medium">Assistenza Studio Nouvelle</p>
          {info.support_email && <p className="text-slate-400 flex items-center gap-2" data-testid="suspended-support-email"><Mail className="h-4 w-4" /> {info.support_email}</p>}
          {info.support_phone && <p className="text-slate-400 flex items-center gap-2" data-testid="suspended-support-phone"><Phone className="h-4 w-4" /> {info.support_phone}</p>}
          {!info.support_email && !info.support_phone && <p className="text-slate-500 text-xs">Contatta il tuo referente Studio Nouvelle.</p>}
        </div>
        <div className="flex flex-col sm:flex-row gap-2">
          {info.support_email && (
            <Button asChild className="flex-1 bg-[#10B981] hover:bg-[#059669] text-[#0A0E17] font-semibold" data-testid="suspended-contact-button">
              <a href={`mailto:${info.support_email}?subject=${subject}`}><Mail className="h-4 w-4 mr-2" /> Contatta l'assistenza</a>
            </Button>
          )}
          <Button variant="outline" className="border-[#1F2937] text-slate-300" onClick={logout} data-testid="suspended-logout"><LogOut className="h-4 w-4 mr-2" /> Esci</Button>
        </div>
      </div>
    </div>
  );
}
